import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
  track: {
    bg: "gray.base",
    _checked: {
      bg: "brand.300",
    },
  },
});

export const switchTheme = defineMultiStyleConfig({ baseStyle });
